import { render, staticRenderFns } from "./userRole.vue?vue&type=template&id=1a7ef496&"
import script from "./userRole.vue?vue&type=script&lang=js&"
export * from "./userRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "userRole.vue"
export default component.exports